export const fixedStatus = [
    {
      id:"lock",
      name:"lock"
    },
    {
      id:"unlock",
      name:"unlock"
    }
  ]